import gql from "graphql-tag";

export const AddBankAccount = gql`
  mutation AddBankAccount (
    $bankInfo: BankInfoInput!
  ) {
    addBankAccount(
      bankInfo: $bankInfo
    )
  }
`;


export const RemoveBankAccount = gql`
 mutation removeBankAccount{
    removeBankAccount
  }
`;


